// angular
// .module("HeroPRO")
// .factory("SelectedProductsFactory", selectedProductsFactory);

import angular from 'angular';
import _ from 'lodash';

/* @ngInject */
export default function selectedProductsFactory(HPConfig, $http, $q, AddProductsConfig, $filter) {
  let getProductPromise;
  let getMaxTermPromise;
  const PREPAY_RESET = {
    title: 'No Prepayment', amount: 0, prepayCAPI: false, prepayFees: false,
  };
  let savedProducts = []; // Copy of products that have been saved to the server
  let selectedProducts = []; // Working copy of products
  let selectedTerm;
  let interestAndFees = {
    ClosingCosts: 0, CAPI: 0, ProjectAmount: 0, TotalCost: 0,
  };
  let prepayOptions = [];
  let selectedPrepayment = PREPAY_RESET;
  let isDirty = false;
  let refreshModal = false;


  function getIsCartDirty() {
    return isDirty;
  }

  function setIsCartDirty(isDirtySetter) {
    isDirty = isDirtySetter;
  }

  function getRefreshModal() {
    return refreshModal;
  }

  function setRefreshModal(refreshModalSetter) {
    refreshModal = refreshModalSetter;
  }

  function removeProducts(FundingRequestId, prodsToDelete) {
    return $http.post(`${HPConfig.heroProApi}Product/RemoveProducts`, { FundingRequestId, ImprovementIds: prodsToDelete });
  }

  function reset() {
    selectedProducts = angular.copy(savedProducts);
    isDirty = false;
  }

  function resetSelectedProducts() {
    savedProducts = [];
    selectedProducts = [];
  }

  function buildProductForSaving(product) {
    const prodToSave = {
      DiscountAmount: 0,
      FinancingAmount: product.InitialRequested,
      ImprovementId: product.ImprovementId === undefined ? 0 : product.ImprovementId,
      IsDiscountApplied: false,
      MonthlyFinancingAmount: 0,
      ProductId: product.EEProductId === undefined ? product.Product.EEProductId : product.EEProductId,
      ProductTypeId: product.EETypeId === undefined ? product.Product.ProductCategory.ProductType.EETypeId : product.EETypeId,
      Attributes: [],
    };
    let isQuantityAdded = false;
    if (!_.isEmpty(product.ImprovementDetails)) {
      _.each(product.ImprovementDetails, (option) => {
        const optToSave = {
          EEProductAttributeName: option.EEProductAttributeName,
          EEProductAttributeNameId: option.EEProductAttributeNameId,
          ImprovementDetailId: option.ImprovementDetailId,
          Options: [],
        };
        if (option.Value !== undefined) {
          optToSave.ImprovementDetailValue = option.Value;
        }
        if (_.contains(AddProductsConfig.quantityEEProductAttributeNameIds, option.EEProductAttributeNameId)) {
          optToSave.ImprovementDetailValue = product.quantity;
          isQuantityAdded = true;
        }
        _.each(option.AtrributeOptionDetails, (optDetail) => {
          const optDetailToSave = {
            EEProductAttributeOptionId: optDetail.EEProductAttributeOptionId,
            OptionName: optDetail.EEProductAttributeOptionName,
          };
          optToSave.Options.push(optDetailToSave);
        });
        prodToSave.Attributes.push(optToSave);
      });
    }
    if (!isQuantityAdded) {
      // if quantity wasn't added
      const attributes = product.InputAttributes || product.Product.Attributes;
      const quantAttribute = _.find(attributes, attribute => _.contains(AddProductsConfig.quantityEEProductAttributeNameIds, attribute.ProductAttributeNameId));
      if (quantAttribute !== undefined && quantAttribute !== null) {
        const qtyToSave = {
          EEProductAttributeName: quantAttribute.Name,
          EEProductAttributeNameId: quantAttribute.ProductAttributeNameId,
          ImprovementDetailId: 0,
          ImprovementDetailValue: product.quantity,
          Options: [],
        };
        prodToSave.Attributes.push(qtyToSave);
      }
    }
    return prodToSave;
  }

  function getProductsForSaving() {
    const productSet = [];
    _.each(selectedProducts, (category) => {
      _.each(category.products, (prodContainer) => {
        const newProdContainer = {};
        if (!prodContainer.primaryProduct.IsDeleted) {
          const primaryProdToSave = buildProductForSaving(prodContainer.primaryProduct);
          newProdContainer.primaryProduct = primaryProdToSave;
        }
        _.each(prodContainer.relatedProducts, (related) => {
          if (!related.IsDeleted) {
            newProdContainer.relatedProducts = newProdContainer.relatedProducts || [];
            const relatedProdToSave = buildProductForSaving(related);
            newProdContainer.relatedProducts.push(relatedProdToSave);
          }
        });
        productSet.push(newProdContainer);
      });
    });
    return productSet;
  }

  function updateInstallDetails(product, details) {
    details = details || product.ImprovementDetails;
    // get input attributes
    const inputAttributeIds = [];
    _.each(_.where(product.Attributes, { IsInputAttribute: true }), (input) => {
      // we only want input attributes that are populated on the product screen
      if (_.contains(AddProductsConfig.quantityEEProductAttributeNameIds, input.ProductAttributeNameId)) {
        inputAttributeIds.push(input.ProductAttributeNameId);
      }
    });

    let installDetails = '';
    _.each(details, (detail) => {
      // is it an install detail
      if (!_.contains(inputAttributeIds, detail.EEProductAttributeNameId) &&
        !_.contains(AddProductsConfig.quantityEEProductAttributeNameIds, detail.EEProductAttributeNameId)) {
        // is it a number or text input
        if (_.isNumber(detail.Value) || !_.isEmpty(detail.Value)) {
          installDetails += _.isEmpty(installDetails) ? '' : ',  ';
          installDetails += `${detail.DisplayName || detail.EEProductAttributeName}: `;
          installDetails += ` ${detail.Value}`;
        } else if (!_.isEmpty(detail.AtrributeOptionDetails)) {
          // it was a radio, dropdown, checkbox
          // was there a choice made - could be an unselected checkbox install detail
          installDetails += _.isEmpty(installDetails) ? '' : ',  ';
          installDetails += `${detail.DisplayName || detail.EEProductAttributeName}: `;
          _.each(detail.AtrributeOptionDetails, (optionDetail) => {
            installDetails += ` ${optionDetail.EEProductAttributeOptionName}`;
          });
        }
      }
    });
    return installDetails;
  }

  function setProductCartAttributes(product, rawProduct) {
    const productTypeId = rawProduct.Product.ProductCategory.ProductType.ProductTypeId;
    product.AmountField = true;
    product.AmountPlaceholder = '$0.00';
    product.QtyField = true;
    product.QtyPlaceholder = 'QTY';
    product.IsDeleted = false;
    product.HasInstallDetails = false;
    product.InstallationDetails = '';
    product.HideEditInstallDetails = false;

    // making sure we pull attributes from the Product if they are missing
    const attributes = rawProduct.Attributes || rawProduct.Product.Attributes;

    // pull the input attributes out, so processRawProductQuantity can find them
    product.InputAttributes = _.filter(attributes, { IsInputAttribute: true });

    // set non input attributes
    product.Attributes = _.reject(attributes, { IsInputAttribute: true });

    // Installation details
    if (!_.isEmpty(product.ImprovementDetails) && _.isEmpty(rawProduct.ImprovementDetails)) {
      product.InstallationDetails = updateInstallDetails(rawProduct, product.ImprovementDetails);
    }
    // local Install details will always overwrite db
    if (!_.isEmpty(rawProduct.ImprovementDetails)) {
      product.ImprovementDetails = rawProduct.ImprovementDetails;
      product.InstallationDetails = updateInstallDetails(rawProduct);
    }
    product.HasInstallDetails = !_.isEmpty(product.InstallationDetails);

    // amount for inverter and copy solar panel install details
    if (_.contains(AddProductsConfig.solarInverterProductTypeIds, productTypeId) && product.ParentId) {
      product.AmountField = false;
      product.InitialRequested = 0;
    }
    if (_.contains(AddProductsConfig.hideQtyFieldProductTypes, productTypeId)) {
      product.QtyField = false;
      product.quantity = 1;
    }
    if (_.contains(AddProductsConfig.hideEditInstallDetailsProductTypes, productTypeId)) {
      product.HideEditInstallDetails = true;
    }
    // hide install details for product types without install detail requirements
    if (_.contains(AddProductsConfig.solarPanelProductTypeIds, productTypeId) || AddProductsConfig.miniSplitHeatPumpProductTypeId === productTypeId) {
      product.HasInstallDetails = false;
    }

    if (_.contains(AddProductsConfig.lnftProductTypes, productTypeId)) {
      product.QtyPlaceholder = 'Ft';
    } else if (_.contains(AddProductsConfig.sqftProductTypes, productTypeId)) {
      product.QtyPlaceholder = 'Sq/Ft';
    }
  }

  function processRawProductQuantity(rawProduct) {
    // Look for the value of the quantity attribute in improvement details
    const EEQuantityAttribute = _.find(rawProduct.ImprovementDetails, improvementDetail => _.contains(AddProductsConfig.quantityEEProductAttributeNameIds, improvementDetail.EEProductAttributeNameId));
    rawProduct.quantity = (EEQuantityAttribute !== undefined) ? Number(EEQuantityAttribute.Value) : '';

    // Look for the definition of the quantity attribute from Product.Attributes
    const quantityAttribute = _.find(rawProduct.InputAttributes, attribute => _.contains(AddProductsConfig.quantityEEProductAttributeNameIds, attribute.ProductAttributeNameId));

    rawProduct.quantityAttribute = quantityAttribute;
    // Parse the min and max values from the Format string
    if (rawProduct.quantityAttribute && rawProduct.quantityAttribute.Format) {
      rawProduct.quantityAttribute.minValue = rawProduct.quantityAttribute.Format.slice(rawProduct.quantityAttribute.Format.indexOf('min:') + 4, rawProduct.quantityAttribute.Format.indexOf('|'));
      rawProduct.quantityAttribute.maxValue = rawProduct.quantityAttribute.Format.slice(rawProduct.quantityAttribute.Format.indexOf('max:') + 4, rawProduct.quantityAttribute.Format.lastIndexOf('|'));
    }

    return rawProduct;
  }

  function processContainerInstallationDetails(prodContainer) {
    // currently only solar needs Install details at the container level
    if (prodContainer.primaryProduct.Product.ProductCategory.ProductCategoryId === 2 &&
      (prodContainer.relatedProducts && prodContainer.relatedProducts.length > 0)) { // if there are not related products i.e. we have a single solar inverter, don't copy install details.
      prodContainer.ContainerDeleted = false;
      prodContainer.InstallationDetails = '';
      prodContainer.InstallationDetails += prodContainer.primaryProduct.InstallationDetails;
      _.each(prodContainer.relatedProducts, (prod) => {
        prodContainer.InstallationDetails += prod.InstallationDetails;
      });
      prodContainer.HasInstallDetails = !_.isEmpty(prodContainer.InstallationDetails);
    }
  }

  function processRawProducts(rawProductData) {
    // This function takes the raw product data from the API and transforms
    // it into a format that is better suited for display in the UI
    const processedProductData = [];

    _.each(rawProductData, (prodContainer) => {
      // set the attributes used by the UI
      setProductCartAttributes(prodContainer.primaryProduct, prodContainer.primaryProduct);
      processRawProductQuantity(prodContainer.primaryProduct);
      // set the attributes for the related products
      _.each(prodContainer.relatedProducts, (relatedProd) => {
        setProductCartAttributes(relatedProd, relatedProd);
        processRawProductQuantity(relatedProd);
      });
      // process the install details at the container level for solar
      processContainerInstallationDetails(prodContainer);

      // See if the category of this product already exists in processedProductData
      const categoryFound = _.find(processedProductData, processedProduct => prodContainer.primaryProduct.Product.ProductCategory.ProductCategoryId === processedProduct.category.ProductCategoryId);

      if (_.isEmpty(categoryFound)) {
        // Category does not exist in processedProductData
        const newCategory = {
          category: _.omit(prodContainer.primaryProduct.Product.ProductCategory, 'ProductType'),
          products: [],
        };
        newCategory.products.push(prodContainer);
        processedProductData.push(newCategory);
      } else {
        // Category already exists in processedProductData
        categoryFound.products.push(prodContainer);
      }
    });

    return processedProductData;
  }

  function setSavedProducts(newSavedProducts) {
    savedProducts = newSavedProducts;
  }

  function setSelectedProducts(newSelectedProducts) {
    if (selectedProducts.length === 0) {
      selectedProducts = newSelectedProducts;
    } else {
      _.each(newSelectedProducts, (newCategory) => {
        const categoryFound = _.find(selectedProducts, currentCategory => newCategory.category.ProductCategoryId === currentCategory.category.ProductCategoryId);
        if (categoryFound === undefined) {
          // it's a new category
          selectedProducts.push(newCategory);
        } else {
          // category exists now lets merge the products
          _.each(newCategory.products, (newProduct) => {
            // find the product
            const foundProduct = _.find(categoryFound.products, product => newProduct.EEProductId === product.EEProductId);
            // if there is no product, add it, otherwise leave it.
            if (foundProduct === undefined) {
              categoryFound.products.push(newProduct);
            }
          });
        }
      });
    }
  }

  function saveAddProducts(FundingRequestId, callback) {
    const addProds = {
      FundingRequestId,
      Products: getProductsForSaving(),
    };
    $http.post(`${HPConfig.heroProApi}Loan/FundingRequest/Products`, addProds).then((response) => {
      // ResultCode will only be present with a number, currently only code 1 is an error
      if (response.data.ResultCode && response.data.ResultCode !== 1) {
        // Shouldn't really need to do this, but the API is returning PrimaryProduct & RelatedProducts
        // and I made the code on the front-end reference primaryProduct & relatedProducts (case sensitive) - MS
        _.each(response.data.Data.SavedProducts, (productContainer) => {
          productContainer.primaryProduct = angular.copy(productContainer.PrimaryProduct);
          delete productContainer.PrimaryProduct;
          productContainer.relatedProducts = angular.copy(productContainer.RelatedProducts);
          delete productContainer.RelatedProducts;
        });

        // done to reset cart, selected products should be moved to saved products after a
        // successful save.
        resetSelectedProducts();
        const processedProductData = processRawProducts(response.data.Data.SavedProducts);
        setSavedProducts(angular.copy(processedProductData));
        setSelectedProducts(angular.copy(processedProductData));
      }
      callback(response);
    });
  }

  function saveProducts(FundingRequestId, callback) {
    // remove deleted products
    const productsToDelete = [];
    _.each(savedProducts, (category) => {
      const currentStateCategory = _.find(selectedProducts, foundCat => category.category.ProductCategoryId === foundCat.category.ProductCategoryId);

      // All products in the category have been deleted, add them all to productsToDelete
      if (currentStateCategory === undefined) {
        _.each(category.products, (prodContainer) => {
          productsToDelete.push(prodContainer.primaryProduct.ImprovementId);
          _.each(prodContainer.relatedProducts, (related) => {
            productsToDelete.push(related.ImprovementId);
          });
        });
      }

      // Not all products in the category have been deleted, determine which to add to productsToDelete
      if (currentStateCategory !== undefined) {
        _.each(category.products, (prodContainer) => {
          const currentStateProd = _.find(currentStateCategory.products, foundProd => (prodContainer.primaryProduct.ImprovementId === foundProd.primaryProduct.ImprovementId) && (foundProd.primaryProduct.IsDeleted === false));
          if (currentStateProd === undefined) {
            productsToDelete.push(prodContainer.primaryProduct.ImprovementId);
            // we assume all related products will be deleted with the primary product
            _.each(prodContainer.relatedProducts, (related) => {
              productsToDelete.push(related.ImprovementId);
            });
          }
        });
      }
    });

    if (productsToDelete.length > 0) {
      // remove product first wait for the response then save products
      removeProducts(FundingRequestId, productsToDelete).then(() => {
        // add/update remaining products
        saveAddProducts(FundingRequestId, callback);
      });
    } else {
      // add/update remaining products
      saveAddProducts(FundingRequestId, callback);
    }
  }

  function createDocuments(data) {
    return $http.post(`${HPConfig.heroProApi}Loan/GenerateFinancingDocs`, data).then(response => response);
  }

  function getAddedProducts(params, clearSelectedProducts) {
    if (clearSelectedProducts) {
      resetSelectedProducts();

      return $http.get(`${HPConfig.heroProApi}Loan/FundingRequest/Products`, { params }).then((response) => {
        // Shouldn't really need to do this, but the API is returning PrimaryProduct & RelatedProducts
        // and I made the code on the front-end reference primaryProduct & relatedProducts (case sensitive) - MS
        _.each(response.data.Data.SavedProducts, (productContainer) => {
          productContainer.primaryProduct = angular.copy(productContainer.PrimaryProduct);
          delete productContainer.PrimaryProduct;
          productContainer.relatedProducts = angular.copy(productContainer.RelatedProducts);
          delete productContainer.RelatedProducts;
        });

        const processedProductData = processRawProducts(response.data.Data.SavedProducts);
        setSavedProducts(angular.copy(processedProductData));
        setSelectedProducts(angular.copy(processedProductData));
      });
    }

    // This needs to be optimized. Returning an empty promise for now since the caller expects it. - MS
    return $q((resolve) => {
      // update the container for any possible edits
      _.each(selectedProducts, (category) => {
        _.each(category.products, (prodContainer) => {
          processContainerInstallationDetails(prodContainer);
        });
      });
      resolve();
    });
  }

  function getProduct(params) {
    getProductPromise = $q((resolve) => {
      $http.get(`${HPConfig.heroProApi}Product/GetProduct`, { params }).then((response) => {
        resolve(response);
      });
    });
    return getProductPromise;
  }

  function getMaxTerm(data) {
    getMaxTermPromise = $q((resolve) => {
      $http.post(`${HPConfig.heroProApi}Product/GetMaxTerm`, data).then((response) => {
        resolve(response);
      });
    });
    return getMaxTermPromise;
  }


  function getSelectedProducts() {
    return selectedProducts;
  }


  function getSelectedProductsCount() {
    let totalProducts = 0;

    _.each(selectedProducts, (productCategory) => {
      totalProducts += productCategory.products.length;
    });

    return totalProducts;
  }

  function getSavedProducts() {
    return savedProducts;
  }


  function processProductContainer(rawProductContainer) {
    const newProductContainer = {
      primaryProduct: {},
      relatedProducts: [],
    };

    // PrimaryProduct
    setProductCartAttributes(newProductContainer.primaryProduct, rawProductContainer.primaryProduct);
    newProductContainer.primaryProduct.InitialRequested = '';
    newProductContainer.primaryProduct.quantity = '';
    newProductContainer.primaryProduct.Product = angular.copy(rawProductContainer.primaryProduct.Product);
    newProductContainer.primaryProduct.Years = '';
    processRawProductQuantity(newProductContainer.primaryProduct);

    // RelatedProducts
    _.each(rawProductContainer.relatedProducts, (relatedProduct, index) => {
      newProductContainer.relatedProducts.push(relatedProduct);
      setProductCartAttributes(newProductContainer.relatedProducts[index], relatedProduct);
      newProductContainer.relatedProducts[index].AmountField = false;
      newProductContainer.relatedProducts[index].InitialRequested = 0;
      newProductContainer.relatedProducts[index].quantity = '';
      newProductContainer.relatedProducts[index].Product = angular.copy(relatedProduct.Product);
      newProductContainer.relatedProducts[index].Years = '';
      processRawProductQuantity(relatedProduct);
    });

    // add category level attributes
    processContainerInstallationDetails(newProductContainer);

    let categoryFound = _.find(selectedProducts, selectedProduct => rawProductContainer.primaryProduct.Product.ProductCategory.ProductCategoryId === selectedProduct.category.ProductCategoryId);

    if (categoryFound !== undefined) {
      categoryFound.products.unshift(newProductContainer);
      // move category to top
      const index = _.findIndex(selectedProducts, selectedProduct => rawProductContainer.primaryProduct.Product.ProductCategory.ProductCategoryId === selectedProduct.category.ProductCategoryId);
      selectedProducts.splice(index, 1);
      selectedProducts.unshift(categoryFound);
    } else {
      // Category does not exist in processedProductData
      categoryFound = {
        category: _.omit(newProductContainer.primaryProduct.Product.ProductCategory, 'ProductType'),
        products: [],
      };
      categoryFound.products.unshift(newProductContainer);
      // push into current state
      selectedProducts.unshift(categoryFound);
    }
  }

  function extractProductAmount(product) {
    if (product.InitialRequested !== undefined && product.InitialRequested !== null && product.InitialRequested !== '') {
      if (typeof product.InitialRequested === 'string') {
        product.InitialRequested = product.InitialRequested.replace(/[^0-9.]+/g, '');
      }
      return product.IsDeleted ? 0 : parseFloat(product.InitialRequested);
    }
    return 0;
  }

  function getProductSubtotal(products) {
    let subTotal = 0.00;
    // might need to new-up this
    let productSet = selectedProducts;
    // this allows controllers to use this logic on external set of products
    // and maintains DRY
    if (!_.isEmpty(products)) {
      productSet = products;
    }

    _.each(productSet, (productCategory) => {
      _.each(productCategory.products, (product) => {
        subTotal += extractProductAmount(product.primaryProduct);
        _.each(product.relatedProducts, (relatedProd) => {
          subTotal += extractProductAmount(relatedProd);
        });
      });
    });

    return subTotal;
  }


  function getFinancingTerm() {
    if (!_.isEmpty(selectedTerm)) {
      return selectedTerm.years;
    }
    if (selectedProducts[0] !== undefined) {
      return selectedProducts[0].products[0].primaryProduct.Years;
    }
    return undefined;
  }

  function setSelectedTerm(term) {
    selectedTerm = term;
  }

  function buildPrePayOptions() {
    const totalIntFees = interestAndFees.TotalCost - interestAndFees.ProjectAmount;
    prepayOptions = [];
    prepayOptions.push({
      title: 'No Prepayment', amount: 0, prepayCAPI: false, prepayFees: false,
    });
    prepayOptions.push({
      title: `Prepay Interest (${$filter('currency')(interestAndFees.CAPI, '$', 2)})`, amount: interestAndFees.CAPI, prepayCAPI: true, prepayFees: false,
    });
    prepayOptions.push({
      title: `Prepay Fees (${$filter('currency')(interestAndFees.ClosingCosts, '$', 2)})`, amount: interestAndFees.ClosingCosts, prepayCAPI: false, prepayFees: true,
    });
    prepayOptions.push({
      title: `Prepay Interest & Fees (${$filter('currency')(totalIntFees, '$', 2)})`, amount: totalIntFees, prepayCAPI: true, prepayFees: true,
    });
  }

  function getInterestAndFees(appInfo) {
    selectedPrepayment = PREPAY_RESET;
    return $q((resolve) => {
      if (_.isEmpty(appInfo) || !_.isObject(appInfo)) {
        resolve(interestAndFees = {
          ClosingCosts: 0, CAPI: 0, ProjectAmount: 0, TotalCost: 0,
        });
      } else {
        const loanData = {
          PlanId: appInfo.PlanId,
          PlanTermSetId: appInfo.PlanTermSetId,
          TermSetId: appInfo.TermSetId,
          Term: getFinancingTerm(),
          ProjectAmount: getProductSubtotal(),
          PrepayCAPI: appInfo.ClosingPrepayCAPI,
          PrepayFees: appInfo.ClosingPrepayFees,
          ApplicationDate: appInfo.ApplicationDate,
          ApprovedThroughDate: appInfo.ApplicationExpirationDate,
        };
        $http.post(`${HPConfig.heroProApi}Product/GetFeesAndCAPI`, loanData).then((response) => {
          if (!_.isEmpty(response.data.Data)) {
            interestAndFees = response.data.Data;
            buildPrePayOptions();
          }
          resolve(interestAndFees);
        });
      }
    });
  }

  function getPrepayOptions() {
    return prepayOptions;
  }

  function setPrepayment(prepayOption) {
    selectedPrepayment = prepayOption;
  }

  function getPrePayment() {
    return selectedPrepayment;
  }

  function getProjectTotal(products) {
    const fees = (interestAndFees.TotalCost - interestAndFees.ProjectAmount) - selectedPrepayment.amount;
    return getProductSubtotal(products) + fees;
  }

  function addProductContainer(productContainer) {
    return $q((resolve) => {
      processProductContainer(productContainer);
      getSelectedProductsCount();
      isDirty = true;
      resolve();
    });
  }

  function removeDeletedProducts(cartState) {
    _.each(cartState, (category) => {
      _.each(category.products, (product) => {
        if (product.IsDeleted) {
          category.products = _.without(category.products, product);
        }
      });
      if (category.products.length === 0) {
        cartState = _.reject(cartState, cartcategory => category.category.ProductCategoryId === cartcategory.category.ProductCategoryId);
      }
    });
    selectedProducts = cartState;
  }

  /*
  function reorderSolarProducts(category) {
      if (!_.isEmpty(category) && category.category.ProductCategoryId === 2) {
          category.products = _.sortBy(category.products, function (product) {
              return product.Product.ProductCategory.ProductType.ProductTypeId;
          });
      }
  }
  */

  function allProductsDeleted() {
    return _.every(selectedProducts, category => category.CategoryDeleted === true);
  }

  return {
    getAddedProducts,
    getSelectedProducts,
    getSelectedProductsCount,
    getSavedProducts,
    getProductSubtotal,
    getFinancingTerm,
    getInterestAndFees,
    getPrePayment,
    getProjectTotal,
    getMaxTerm,
    getProduct,
    addProductContainer,
    removeDeletedProducts,
    saveProducts,
    createDocuments,
    allProductsDeleted,
    setSelectedTerm,
    getPrepayOptions,
    setPrepayment,
    getIsCartDirty,
    setIsCartDirty,
    getRefreshModal,
    setRefreshModal,
    reset,
    updateInstallDetails,
  };
}



// WEBPACK FOOTER //
// ./src/app/appDetail/addProducts/selectedProducts/selectedProductsFactory.js